(function () {
  'use strict';

  function initInstafeedSlider() {
    document.querySelectorAll('#insta-feed').forEach(setupSlider);
  }

  function setupSlider(feed) {
    if (feed.dataset.sliderReady === '1') return;
    const wrapper = feed.querySelector('.instafeed-new-layout-wrapper');
    if (!wrapper) return;

    const section = feed.closest('.section-y-spacing') || feed.closest('section');
    if (!section) return;

    section.classList.add('instafeed-as-slider');
    feed.dataset.sliderReady = '1';

    // Locate the title's flex row inside the same section — the outer .block-layout-flex.
    const flexRow = section.querySelector('.block-layout-flex');
    if (flexRow) injectNav(flexRow, wrapper);

    injectScrollbar(feed, wrapper);
  }

  function injectNav(flexRow, wrapper) {
    if (flexRow.querySelector('.instafeed-slider-nav')) return;

    const nav = document.createElement('div');
    nav.className = 'instafeed-slider-nav';
    nav.innerHTML =
      '<button type="button" class="instafeed-slider-nav__btn" data-if-prev aria-label="Previous">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>' +
      '</button>' +
      '<button type="button" class="instafeed-slider-nav__btn" data-if-next aria-label="Next">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>' +
      '</button>';
    // Append as a sibling flex-item — the row is justify-between, so it lands on the right.
    flexRow.appendChild(nav);

    const prev = nav.querySelector('[data-if-prev]');
    const next = nav.querySelector('[data-if-next]');

    const pageWidth = () => wrapper.clientWidth * 0.9;
    prev.addEventListener('click', () =>
      wrapper.scrollBy({ left: -pageWidth(), behavior: 'smooth' })
    );
    next.addEventListener('click', () =>
      wrapper.scrollBy({ left: pageWidth(), behavior: 'smooth' })
    );

    const update = () => {
      const max = wrapper.scrollWidth - wrapper.clientWidth;
      prev.disabled = wrapper.scrollLeft <= 1;
      next.disabled = wrapper.scrollLeft >= max - 1;
    };
    update();
    wrapper.addEventListener('scroll', update, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(wrapper);
  }

  function injectScrollbar(feed, wrapper) {
    if (feed.querySelector('.instafeed-slider-scrollbar')) return;

    const bar = document.createElement('div');
    bar.className = 'instafeed-slider-scrollbar';
    bar.innerHTML = '<span class="instafeed-slider-scrollbar__thumb"></span>';
    wrapper.after(bar);

    const thumb = bar.querySelector('.instafeed-slider-scrollbar__thumb');

    const sync = () => {
      const sw = wrapper.scrollWidth;
      const cw = wrapper.clientWidth;
      if (sw <= cw) {
        bar.style.display = 'none';
        return;
      }
      bar.style.display = 'block';
      const thumbPct = Math.min(100, (cw / sw) * 100);
      const max = sw - cw;
      const posPct = max > 0 ? (wrapper.scrollLeft / max) * (100 - thumbPct) : 0;
      thumb.style.width = thumbPct + '%';
      thumb.style.left = posPct + '%';
    };
    sync();
    wrapper.addEventListener('scroll', sync, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(wrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInstafeedSlider);
  } else {
    initInstafeedSlider();
  }

  // Instafeed lazy-renders; re-check as new nodes appear.
  const mo = new MutationObserver(() => initInstafeedSlider());
  mo.observe(document.body, { childList: true, subtree: true });

  // Open an accordion when the URL hash matches its `anchor--<slug>` class,
  // then scroll it into view. Works for any accordion tagged with that class,
  // so new sections need no code change — only the class in the customizer.
  function openAccordionFromHash(attempt) {
    var raw = (window.location.hash || '').replace(/^#/, '');
    if (!raw) return;

    var slug;
    try {
      slug = decodeURIComponent(raw);
    } catch (e) {
      slug = raw;
    }
    if (!slug) return;

    var target = document.querySelector('.js-accordion-anchor.anchor--' + CSS.escape(slug));
    if (!target) {
      // Alpine / block hydration can lag; retry a few times before giving up.
      if ((attempt || 0) < 20) {
        setTimeout(function () { openAccordionFromHash((attempt || 0) + 1); }, 100);
      }
      return;
    }

    var header = target.querySelector('button[id^="AccordionHeader-"]');
    if (!header) {
      if ((attempt || 0) < 20) {
        setTimeout(function () { openAccordionFromHash((attempt || 0) + 1); }, 100);
      }
      return;
    }

    var isOpen = header.getAttribute('aria-expanded') === 'true';
    if (!isOpen) header.click();

    // Let the panel expand before measuring scroll position.
    setTimeout(function () {
      try {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (e) {
        var rect = target.getBoundingClientRect();
        window.scrollTo(0, window.pageYOffset + rect.top);
      }
    }, 60);
  }

  function scheduleAccordionFromHash() {
    // Two frames + a small delay gives Alpine time to initialise its stores
    // and remove x-cloak on the accordion contents.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        setTimeout(openAccordionFromHash, 50);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleAccordionFromHash);
  } else {
    scheduleAccordionFromHash();
  }
  window.addEventListener('hashchange', function () { openAccordionFromHash(0); });

  // Hide product-page accordions whose content panel is empty. Accordions
  // pull from product metafields (material, care, montaz, ...); when a
  // metafield is blank, Shopify still renders wrapper markup, so checking
  // trimmed textContent of `.AccordionPanel` is the reliable signal.
  function isProductPage() {
    return document.body && document.body.classList.contains('product');
  }

  function hideEmptyAccordions() {
    if (!isProductPage()) return;
    document.querySelectorAll('.block-accordion').forEach(function (accordion) {
      if (accordion.dataset.emptyChecked === '1') return;
      var panel = accordion.querySelector('.AccordionPanel');
      if (!panel) return;
      var text = (panel.textContent || '').replace(/ /g, ' ').trim();
      if (text === '') {
        accordion.style.display = 'none';
      }
      accordion.dataset.emptyChecked = '1';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideEmptyAccordions);
  } else {
    hideEmptyAccordions();
  }

  (() => {
    const OVERLAY_SEL = '[class*="_overlayBackground_"]';
    // Popup grid (image + content) — hashed classes, isliye attribute selectors
    const GRID_SEL = '[class*="_grid_"][class*="_left_"], [class*="_grid_"][class*="_right_"]';
    // Mobile pe image row ki height (app default 250px)
    const MOBILE_IMAGE_HEIGHT = '250px';
    // Theme ka sharp_regular xmark (c__icon--sharp-regular.liquid), cart drawer jaisa
    const XMARK = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'%3E%3Cpath d='M39.5 105l-17-17 33.9-33.9 17 17 151 151 151-151 17-17 33.9 33.9-17 17-151 151 151 151 17 17-33.9 33.9-17-17-151-151-151 151-17 17-33.9-33.9 17-17 151-151-151-151z'/%3E%3C/svg%3E";

    // App ka apna overlay transparent — popup ke peeche koi background/blur nahi
    const sheet = new CSSStyleSheet();
      sheet.replaceSync(`

        /* Square corners: popup box, button, email input */
        :host, * {
          --container-border-radius: 0 !important;
          --button-border-radius: 0 !important;
          --form-field-border-radius: 0 !important;
        }
        /* Heading, text aur disclaimer left aligned */
        :host, * {
          --container-text-alignment: left !important;
        }
        /* Font theme setting se (theme__styles.liquid ka --type__body-family) */
        :host, * {
          font-family: var(--type__body-family, inherit) !important;
        }
        /* Message section tighter (client Figma, Oct 2026): kam padding aur gaps.
           X ab heading ki first line pe hai (client, 2 Nov 2026), isliye top bhi 18px */
        [class*="_gridItemContent_"] {
          padding: 18px !important;
        }
        section[class*="_formHeader_"] {
          margin: 0 0 4px !important;
        }
        /* Heading 20px desktop + mobile (client, 2 Nov 2026). padding-right: X glyph (15.75px) + gap, text X ke neeche kabhi nahi jaata */
        :host, * {
          --forms-heading-font-size: 20px !important;
        }
        h2[class*="_textHeading_"] {
          font-size: 20px !important;
          font-weight: 400 !important;
          line-height: 1.2 !important;
          margin-bottom: 8px !important;
          padding-right: 30px !important;
        }
        [class*="_textBody_"] {
          line-height: 1.35 !important;
        }
        /* X heading ki first line ke centre pe: top padding 18px + aadhi line (20px x 1.2 / 2) - aadha button (32px / 2).
           Right 9px = glyph panel edge se ~18px. Content panel card ke top pe hai, desktop aur mobile dono */
        div[class*="_formContainerCloseButtonPosition_"] {
          top: calc(18px + 20px * 1.2 / 2 - 16px) !important;
          right: 9px !important;
        }
        [class*="_formCloseButton_"] {
          width: 32px !important;
          height: 32px !important;
          background: transparent !important;
          border-radius: 0 !important;
        }
        /* App ka rounded X chhupao, cart drawer wala sharp_regular xmark mask se draw karo */
        [class*="_formCloseButton_"] svg {
          display: none !important;
        }
        [class*="_formCloseButton_"]::before {
          content: "";
          width: 15.75px;
          height: 18px;
          background-color: rgb(31, 31, 31);
          -webkit-mask: url("${XMARK}") center / contain no-repeat;
          mask: url("${XMARK}") center / contain no-repeat;
        }
        /* Input, button aur disclaimer heading ke saath ek hi left edge pe */
        [class*="_formFieldset_"] {
          padding: 0 !important;
        }
        /* Email field = button jaisa size (Jakub, 31 Oct 2026). App ka border box-shadow hai jo
           bahar 1px nikalta tha, isliye inset kiya: outer width/edges button ke barabar.
           Height button ka formula (padding x2 + 1.1 line-height), border-box ke saath */
        input[class*="_formInputField_"] {
          box-sizing: border-box !important;
          height: calc(var(--button-padding) * 2 + 1.1em) !important;
          padding-top: 20px !important;
          padding-bottom: 7px !important;
          box-shadow: inset var(--form-field-border) !important;
        }
        input[class*="_formInputField_"]:focus-visible {
          box-shadow: inset var(--form-field-border-focused) !important;
        }
        /* "Email" label field ke beech mein (app inline top: 17px deta hai, 48px field ke liye) */
        label[class*="_formInputFieldLabel_"] {
          top: calc(var(--button-padding) + 0.05em) !important;
        }
        div[class*="_formDisclaimer_"] {
          padding: 0 !important;
          margin-top: 14px !important;
          font-size: 11px !important;
          line-height: 1.4 !important;
        }
        /* Disclaimer ke dono sentences (do alag <p>) ke beech thoda gap, aadhi line jitna (Jakub, 31 Oct 2026) */
        div[class*="_formDisclaimer_"] p + p {
          margin-top: 8px !important;
        }
        /* Mobile: text upar, image neeche (client request), image row height override */
        @media screen and (max-width: 768px) {
          ${GRID_SEL} {
            grid-template: "content" min-content "image" ${MOBILE_IMAGE_HEIGHT} / 1fr !important;
          }
        }
      `);

    const apply = (host) => {
      const root = host.shadowRoot;
      if (!root || root.adoptedStyleSheets.includes(sheet)) return;
      root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
    };

    const scan = () => document.querySelectorAll('shopify-forms-embed').forEach(apply);
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
    const t = setInterval(scan, 500);
    setTimeout(() => clearInterval(t), 15000);
  })();
})();
